'/create-folder/:parentId';

import Config from 'Config';
import axios from 'axios';
import { createSignedRequest } from 'utils/createSignedRequest';

export const postTransferFolderStructureToProject = async ({
  targetProjectId,
  sourceProjectId,
}) => {
  const apiPath = `project-bank/${targetProjectId}/transfer-folder-structure`;

  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ targetProjectId, sourceProjectId }), // aws4 looks for body; axios for data
    data: { targetProjectId, sourceProjectId },
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
